module.exports = __webpack_public_path__ + "static/media/Internet.9ead5bf3.svg";